import React, { useState } from 'react'
import { ICharacter, IDiceRoll } from '../../../../../../../../api/types/character'
import { useGlobalError } from '../../../../../../../../context/GlobalError'
import { useMutation } from '@tanstack/react-query'
import { mutationDiceRoll } from '../../../../../../../../api/mutations'
import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Theme,
  Typography,
} from '@mui/material'
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { extractMessage } from '../../../../../../../../utils'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    input: {
      width: '36px',
    },
    select: {
      width: '62px',
    },
  })
)

interface Props {
  game_id: number
  char: ICharacter
  showChatTab?: () => void
}

export const DiceRolls: React.FC<Props> = ({ game_id, char, showChatTab }) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const [count, setCount] = useState(1)
  const [dice, setDice] = useState(20)
  const [sign, setSign] = useState('+')
  const [mod, setMod] = useState(0)
  const { mutate: rollMutation, isLoading: isMutating } = useMutation(
    (roll: IDiceRoll) => mutationDiceRoll(char.id, roll),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się wykonać rzutu', err?.status)
      },
      onSuccess: (data: any) => {
        showChatTab && showChatTab()
      },
    }
  )

  return (
    <div>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        Kości
      </Typography>
      <div className={classes.root}>
        <TextField
          className={classes.input}
          type="number"
          size="small"
          variant="standard"
          value={count}
          onChange={e => setCount(Number(e.target.value))}
          inputProps={{
            min: 1,
            max: 99,
          }}
        />

        <FormControl>
          <Select
            // @ts-ignore
            className={classes.select}
            variant="standard"
            size="small"
            value={dice}
            onChange={e => setDice(Number(e.target.value))}
          >
            <MenuItem value={2}>K2</MenuItem>
            <MenuItem value={4}>K4</MenuItem>
            <MenuItem value={6}>K6</MenuItem>
            <MenuItem value={8}>K8</MenuItem>
            <MenuItem value={10}>K10</MenuItem>
            <MenuItem value={12}>K12</MenuItem>
            <MenuItem value={20}>K20</MenuItem>
            <MenuItem value={100}>K100</MenuItem>
          </Select>
        </FormControl>
        <FormControl>
          <Select
            sx={{ width: '32px' }}
            variant="standard"
            size="small"
            value={sign}
            onChange={e => setSign(e.target.value)}
          >
            <MenuItem value={'+'}>+</MenuItem>
            <MenuItem value={'-'}>-</MenuItem>
          </Select>
        </FormControl>
        <TextField
          type={'number'}
          variant={'standard'}
          className={classes.input}
          sx={{ paddingBottom: '4px' }}
          value={mod}
          onChange={e => setMod(Number(e.target.value))}
          inputProps={{ min: 0, max: 99 }}
        />

        <IconButton
          size="small"
          disabled={isMutating}
          onClick={() =>
            rollMutation({
              game_id,
              count,
              dice,
              mod: sign === '+' ? mod : -mod,
            })
          }
        >
          <CasinoRoundedIcon color={'primary'} fontSize={'large'} />
        </IconButton>
      </div>
    </div>
  )
}
